import { useCallback, useState } from "react";
import type { GPUInstanceType } from "types/InstanceTypes";

interface UseLaunchableComputeSelectionOptions {
  launchableId: string;
  intendedInstance: GPUInstanceType | null | undefined;
  intendedStorage: string | null | undefined;
}

export const useLaunchableComputeSelection = ({
  launchableId,
  intendedInstance,
  intendedStorage,
}: UseLaunchableComputeSelectionOptions) => {
  const [editedSelection, setEditedSelection] = useState<{
    launchableId: string;
    instanceType: GPUInstanceType | null;
    storage: string | null;
  } | null>(null);
  const hasEditedCurrentLaunchable =
    editedSelection?.launchableId === launchableId;
  const instanceType = hasEditedCurrentLaunchable
    ? editedSelection.instanceType
    : (intendedInstance ?? null);
  const storage = hasEditedCurrentLaunchable
    ? editedSelection.storage
    : (intendedStorage ?? null);

  const setSelection = useCallback(
    (nextInstanceType: GPUInstanceType | null, nextStorage: string) => {
      setEditedSelection({
        launchableId,
        instanceType: nextInstanceType,
        storage: nextStorage,
      });
    },
    [launchableId],
  );

  return {
    instanceType,
    storage,
    setSelection,
  };
};
